; (function (module) {
  'use strict'
  module.controller('smsHistoryController', [
    '$scope',
    'progressBar',
    'historySms',
    'tripsDashBoard',
    'currency',
    'uiGridConstants',
    'clientSelectService',
    'agencySelectService',
    '$timeout',
    function (
      $scope,
      progressBar,
      historySms,
      tripsDashBoard,
      currency,
      uiGridConstants,
      clientSelectService,
      agencySelectService,
      $timeout,
    ) {
      const progress = progressBar.getProgressBar()
      let gridData = []
      $scope.showConversation = false
      $scope.selectedRow = null
      $scope.dateTo = new Date()
      $scope.dateFrom = moment($scope.dateTo).add(-1, 'week').toDate()

      const paginationOptions = {
        pageNumber: 1,
        pageSize: 25,
        sort: null,
      }
      const gridOptions = {
        paginationPageSizes: [5, 10, 25, 50],
        enableFiltering: true,
        enableGridMenu: true,
        paginationPageSize: 25,
        useExternalPagination: false,
        useExternalSorting: false,
        enableRowSelection: true,
        enableSelectAll: false,
        enableRowHeaderSelection: false,
        multiSelect: false,
        enableColumnResizing: true,
        columnDefs: [
          {
            name: 'DisplayName',
            displayName: 'Traveler',
            enableHiding: true,
            enableSorting: true,
            enableFiltering: true,
            sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC],
            enableColumnResizing: true,
            maxWidth: 250,
          },
          {
            name: 'AgentName',
            displayName: 'Agent',
            enableHiding: true,
            enableSorting: true,
            enableFiltering: true,
            sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC],
            enableColumnResizing: true,
            maxWidth: 250,
          },
          {
            name: 'Phone',
            displayName: 'Phone',
            enableHiding: true,
            enableSorting: true,
            enableFiltering: true,
            sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC],
            enableColumnResizing: true,
            maxWidth: 250,
          },
          {
            name: 'Email',
            displayName: 'Primary Email',
            visible: true,
            enableHiding: true,
            enableSorting: true,
            enableFiltering: true,
            sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC],
            enableColumnResizing: true,
            maxWidth: 250,
          },
          {
            name: 'AlternateEmail',
            displayName: 'Alternate Email',
            visible: true,
            enableHiding: true,
            enableSorting: true,
            enableFiltering: true,
            sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC],
            enableColumnResizing: true,
            maxWidth: 250,
          },
          {
            name: 'LastUpdated',
            displayName: 'Time',
            enableHiding: true,
            enableSorting: true,
            enableFiltering: true,
            sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC],
            maxWidth: 250,
            enableColumnResizing: true,
            sort: {
              direction: uiGridConstants.DESC,
              priority: 0,
            },
          },
          {
            name: 'Message',
            displayName: 'Message',
            enableHiding: false,
            enableSorting: false,
            enableFiltering: false,
            enableColumnResizing: true,
          },
          {
            name: 'Conversation',
            displayName: '',
            visible: false,
            enableHiding: false,
          },
          {
            name: 'Channel',
            displayName: '',
            visible: false,
            enableHiding: false,
          },
          {
            name: 'CarId',
            displayName: '',
            visible: false,
            enableHiding: false,
          },
          {
            name: 'FlightId',
            displayName: '',
            visible: false,
            enableHiding: false,
          },
          {
            name: 'HotelId',
            displayName: '',
            visible: false,
            enableHiding: false,
          },
          {
            name: 'TripId',
            displayName: '',
            visible: false,
            enableHiding: false,
          },
          {
            name: 'TravelAgents',
            displayName: '',
            visible: false,
            enableHiding: false,
          },
        ],
      }

      $scope.gridDetails = _.cloneDeep(gridOptions)
      $scope.gridDetails.onRegisterApi = function (gridApi) {
        $scope.gridApi = gridApi
        $scope.gridApi.core.on.sortChanged($scope, function (
          grid,
          sortColumns,
        ) {
          if (!sortColumns.length) {
            paginationOptions.sort = null
          } else {
            paginationOptions.sort = sortColumns[0].sort.direction
          }
          updateGridPagination(gridData)
        })
        gridApi.pagination.on.paginationChanged($scope, function (
          newPage,
          pageSize,
        ) {
          paginationOptions.pageNumber = newPage
          paginationOptions.pageSize = pageSize
          updateGridPagination(gridData)
        })
        //Show trip booking details on grid row selection.
        gridApi.selection.on.rowSelectionChanged($scope, (row) => {
          if ($scope.selectedRow === row) {
            $scope.showConversation = !$scope.showConversation
          } else {
            $scope.showConversation = true
            $scope.selectedRow = row
          }
          if ($scope.showConversation) {
            $scope.hasNonTripContext =
              !!row.entity.CarId ||
              !!row.entity.FlightId ||
              !!row.entity.HotelId
            $scope.hasTripContext = !!row.entity.TripId

            $scope.TravelerName = row.entity.DisplayName
            $scope.TravelerPhone = row.entity.Phone
            $scope.Email = row.entity.Email
            $scope.Channel = row.entity.Channel
            populateChatPanel(
              row.entity.DisplayName,
              row.entity.Conversation,
              row.entity.AgentName,
              row.entity.TravelAgents,
            )
            populateContextPanel(
              row.entity.CarId,
              row.entity.FlightId,
              row.entity.HotelId,
              row.entity.TripId,
            )
          }
        })
      }

      const populateChatPanel = function (
        travelerName,
        conversation,
        agentName,
        travelAgents,
      ) {
        progress.start()
        historySms
          .getDetailedConversation(conversation)
          .then((response) => {
            const chatMessages = response.data
            console.log(chatMessages)

            $scope.chats = chatMessages.map((conversationMsg) => {
              let message
              let template
              let templateType
              let arrMsgTempDetails = {}
              let img = ''
              let direction = ''
              if (conversationMsg.Message.indexOf('{') !== -1) {
                img = 'images/avatar/bot.png'
                direction = 'out'
                const msgTemplate = JSON.parse(conversationMsg.Message)
                templateType = msgTemplate.template_type
                template = {}
                if (
                  templateType === 'airline_itinerary' ||
                  templateType === 'airline_checkin' ||
                  templateType === 'airline_update'
                ) {
                  const flightInfo =
                    msgTemplate.update_flight_info !== undefined
                      ? msgTemplate.update_flight_info
                      : msgTemplate.flight_info[0]
                  template = {
                    intro_message: msgTemplate.intro_message,
                    pnr_number: msgTemplate.pnr_number,
                    flight_info: {
                      flight_schedule: {
                        departure_time:
                          flightInfo.flight_schedule.departure_time,
                      },
                      departure_airport: {
                        city: flightInfo.departure_airport.city,
                        airport_code: flightInfo.departure_airport.airport_code,
                      },
                      arrival_airport: {
                        city: flightInfo.arrival_airport.city,
                        airport_code: flightInfo.arrival_airport.airport_code,
                      },
                    },
                  }
                  if (templateType === 'airline_itinerary') {
                    template.passenger_info = {
                      name: msgTemplate.passenger_info[0].name,
                    }
                    template.total_price = msgTemplate.total_price
                    template.currency = msgTemplate.currency
                  }
                } else if (templateType === 'generic') {
                  template = []
                  template: msgTemplate.elements.map((m) => {
                    return {
                      title: m.title,
                      subtitle: m.subtitle,
                      image_url: m.image_url,
                    }
                  })
                } else if (templateType === 'list') {
                  template = []
                  template: msgTemplate.elements.map((m) => {
                    return {
                      title: m.title,
                      subtitle: m.subtitle,
                    }
                  })
                }
              } else {
                message = conversationMsg.Message
                img =
                  conversationMsg.AgentId === null
                    ? 'images/avatar/traveler.png'
                    : 'images/avatar/agent.png'
                direction = conversationMsg.AgentId === null ? 'in' : 'out'
              }
              arrMsgTempDetails = {
                direction: direction,
                img: img,
                time: moment
                  .utc(conversationMsg.LastUpdated)
                  .local()
                  .format('MM-DD-YYYY H:mm:ss'),
                mediaUrl0: conversationMsg.mediaUrl0,
                mediaUrl1: conversationMsg.mediaUrl1,
                mediaUrl2: conversationMsg.mediaUrl2,
              }
              if (conversationMsg.Message.indexOf('{') !== -1) {
                ; (arrMsgTempDetails.templateType = templateType),
                  (arrMsgTempDetails.template = template)
              } else {
                arrMsgTempDetails.message = message
              }

              if (conversationMsg.Message.indexOf('{') !== -1) {
                arrMsgTempDetails.name = 'Obex Bot'
              } else if (
                conversationMsg.Channel === 'messenger' &&
                conversationMsg.IsBot === true
              ) {
                arrMsgTempDetails.name = 'Obex Bot'
                arrMsgTempDetails.direction = 'out'
              } else if (travelAgents.length < 2 || !conversationMsg.AgentId) {
                arrMsgTempDetails.name =
                  conversationMsg.AgentId === null
                    ? travelerName + '(' + conversationMsg.Phone + ')'
                    : agentName
              } else {
                travelAgents.forEach(function (travelAgent) {
                  if (travelAgent.Id === conversationMsg.AgentId) {
                    arrMsgTempDetails.name =
                      travelAgent.FirstName + ' ' + travelAgent.LastName
                  }
                })
              }
              return arrMsgTempDetails
            })
          })
          .catch((err) => {
            console.log(err)
          })
          .finally(function () {
            progress.complete()
          })
      }

      const populateContextPanel = function (carId, flightId, hotelId, tripId) {
        if (tripId) {
          populateTripContextPanel(tripId)
        } else if (carId) {
          populateCarContextPanel(carId)
        } else if (flightId) {
          populateFlightContextPanel(flightId)
        } else if (hotelId) {
          populateHotelContextPanel(hotelId)
        }
      }

      const populateCarContextPanel = (carId) => {
        tripsDashBoard
          .getCarsDashById(carId)
          .then((response) => {
            const contextData = response.data
            $scope.bookingType = 'Car Reservation'

            $scope.carContext = {
              pnr: contextData.Pnr,
              rentalCompany: contextData.RentalCompany,
              pickupDateTime: moment(contextData.PickUpDateTime).format(
                'MM-DD-YYYY h:mm',
              ),
              pickupLocation: contextData.PickUpLocation,
              pickupLocationIsAirport:
                contextData.PickUpAtAirport === true ? 'Yes' : 'No',
              pickupLocationPhoneNumber: contextData.PickUpLocationPhoneNumber,
              pickupLocationCode: contextData.PickUpLocationCode,
              dropoffDateTime: moment(contextData.DropOffDateTime).format(
                'MM-DD-YYYY h:mm',
              ),
              dropoffLocation: contextData.DropOffLocation,
              dropoffLocationIsAirport:
                contextData.DropOffAtAirport === true ? 'Yes' : 'No',
              dropoffLocationPhoneNumber:
                contextData.DropOffLocationPhoneNumber,
              dropoffLocationCode: contextData.DropOffLocationCode,
              carModel: contextData.CarModel,
              confirmation: contextData.Confirmation,
              bookingSource: contextData.BookingSource,
              totalCharge:
                contextData.TotalCharge +
                ' ' +
                (contextData.CurrencyCode === null
                  ? ''
                  : contextData.CurrencyCode),
              lastUpdated: moment(contextData.Updated).format(
                'MM-DD-YYYY h:mm:ss',
              ),
              isDeleted: contextData.Deleted === true ? 'Yes' : 'No',
            }
          })
          .catch((err) => {
            console.log(err)
          })
      }

      const populateFlightContextPanel = (flightId) => {
        tripsDashBoard
          .getFlightsDashById(flightId)
          .then((response) => {
            const contextData = response.data
            $scope.bookingType = 'Airline Reservation'

            let statusColor = '#000000' //black
            let flightStatus = 'scheduled'
            const dateTime = new Date()
            const arrivalTime = moment(contextData.ArrivalDateTime).format(
              'MM-DD-YYYY h:mm:ss',
            )
            const currentDateTime = moment(dateTime).format(
              'MM-DD-YYYY h:mm:ss',
            )
            if (contextData.FlightStat !== null) {
              const departureTime = moment(
                contextData.DepartureDateTime,
              ).format('MM-DD-YYYY h:mm:ss')
              const estimatedDeparuteTime = moment(
                contextData.FlightStat.EstimatedDeparture,
              ).format('MM-DD-YYYY h:mm:ss')
              const estimatedArrival = moment(
                contextData.FlightStat.EstimatedArrival,
              ).format('MM-DD-YYYY h:mm:ss')
              statusColor =
                departureTime === estimatedDeparuteTime ||
                  estimatedDeparuteTime < departureTime
                  ? '#3d9400'
                  : estimatedDeparuteTime > departureTime
                    ? '#cc0000'
                    : statusColor
              flightStatus =
                departureTime === estimatedDeparuteTime ||
                  estimatedDeparuteTime < departureTime
                  ? 'on time'
                  : estimatedDeparuteTime > departureTime
                    ? 'delayed'
                    : currentDateTime > estimatedArrival
                      ? 'past flight'
                      : flightStatus
            }
            if (contextData.Cancelled === true) {
              statusColor = '#cc0000' //red
              flightStatus = 'cancelled'
            }
            if (
              contextData.FlightStat === null &&
              currentDateTime > arrivalTime
            ) {
              flightStatus = 'past flight'
            }
            $scope.flightContext = {
              statusColor: statusColor,
              flightStatus: flightStatus,
              estimatedDeparture:
                contextData.FlightStat !== null &&
                  contextData.FlightStat.EstimatedDeparture !== null
                  ? contextData.FlightStat.EstimatedDeparture
                  : contextData.DepartureDateTime,
              estimatedArrival:
                contextData.FlightStat !== null &&
                  contextData.FlightStat.EstimatedArrival !== null
                  ? contextData.FlightStat.EstimatedArrival
                  : contextData.ArrivalDateTime,
              pnr: contextData.Pnr,
              depart:
                contextData.DepartureName +
                ' (' +
                contextData.DepartureAirport +
                ')',
              arrival:
                contextData.ArrivalName +
                ' (' +
                contextData.ArrivalAirport +
                ')',
              departureName: contextData.DepartureName,
              departureAirport: contextData.DepartureAirport,
              departureDateTime: moment(contextData.DepartureDateTime).format(
                'MM-DD-YYYY h:mm:ss',
              ),
              departureGate:
                contextData.FlightStat !== null &&
                  contextData.FlightStat.DepartureGate !== null
                  ? contextData.FlightStat.DepartureGate
                  : '-',
              departureTerminal:
                contextData.FlightStat !== null &&
                  contextData.FlightStat.DepartureTerminal !== null
                  ? contextData.FlightStat.DepartureTerminal
                  : '-',
              startDate: contextData.DepartureDateTime,
              endDate: contextData.ArrivalDateTime,
              arrivalName: contextData.ArrivalName,
              arrivalAirport: contextData.ArrivalAirport,
              arrivalDateTime: moment(contextData.ArrivalDateTime).format(
                'MM-DD-YYYY h:mm:ss',
              ),
              arrivalGate:
                contextData.FlightStat !== null &&
                  contextData.FlightStat.ArrivalGate !== null
                  ? contextData.FlightStat.ArrivalGate
                  : '-',
              arrivalTerminal:
                contextData.FlightStat !== null &&
                  contextData.FlightStat.ArrivalTerminal !== null
                  ? contextData.FlightStat.ArrivalTerminal
                  : '-',
              operatingAirline: contextData.OperatingAirline,
              flightNumber: contextData.FlightNumber,
              duration: contextData.Duration,
              bookingSource: contextData.BookingSource,
              confirmation: contextData.ConfirmationNumber,
              cabin: contextData.Cabin,
              bookingClass: contextData.BookingClass,
              numberInParty: contextData.NumberInParty,
              airTravelers: contextData.AirReservation.AirTravelers,
              //airTravelers: Object.keys(contextData.AirReservation.AirTravelers).map(function(x){return contextData.AirReservation.AirTravelers[x].Name}).join(','),
              comment: contextData.AirReservation.Comment,
              seats: contextData.Seats,
              totalCharge:
                currency.getCurrencySymbol(
                  contextData.AirReservation.CurrencyCode,
                ) + contextData.AirReservation.TotalFare,
              lastUpdated: moment(contextData.Updated).format(
                'MM-DD-YYYY h:mm:ss',
              ),
              isDeleted: contextData.Deleted ? 'Yes' : 'No',
              vendor: contextData.Vendor,
            }
          })
          .catch((err) => {
            console.log(err)
          })
      }

      const populateHotelContextPanel = (hotelId) => {
        tripsDashBoard
          .getHotelsDashById(hotelId)
          .then((response) => {
            const contextData = response.data
            $scope.bookingType = 'Hotel Reservation'

            $scope.hotelContext = {
              pnr: contextData.Pnr,
              hotelName: contextData.HotelName,
              address: contextData.Address,
              checkinDate: moment(contextData.CheckInDate).format('MM-DD-YYYY'),
              checkoutDate: moment(contextData.CheckOutDate).format(
                'MM-DD-YYYY',
              ),
              confirmation: contextData.Confirmation,
              bookingSource: contextData.BookingSource,
              guestNames: contextData.GuestNames,
              numberOfRooms: contextData.NumberOfRooms,
              roomType: contextData.RoomType,
              totalCharge:
                contextData.Total +
                ' ' +
                (contextData.CurrencyCode === null
                  ? ''
                  : contextData.CurrencyCode),
              lastUpdated: moment(contextData.Updated).format(
                'MM-DD-YYYY h:mm:ss',
              ),
              isDeleted: contextData.Deleted === true ? 'Yes' : 'No',
            }
          })
          .catch((err) => {
            console.log(err)
          })
      }

      const populateTripContextPanel = (tripId) => {
        tripsDashBoard
          .getTripsDashbyId(tripId)
          .then((response) => {
            const trips = response.data
            if (trips) {
              const flightList = mapFlightContext(trips.Flights)
              const hotelList = mapCarContext(trips.Cars)
              const carList = mapHotelContext(trips.Hotels)
              const limoList = mapLimoContext(trips.Limos)
              const contextList = [
                flightList,
                carList,
                hotelList,
                limoList,
              ].reduce(function (prevData, currData) {
                return prevData.concat(currData)
              }, [])

              contextList.sort(sortByDateAsc)
              $scope.contextList = contextList
            } else {
              $scope.contextList = []
            }
          })
          .catch((err) => {
            console.log(err)
          })
      }

      const sortByDateAsc = (a, b) => {
        let firstStartDate = moment(a.startDate).format('MM-DD-YYYY')
        let secondStartDate = moment(b.startDate).format('MM-DD-YYYY')
        if (firstStartDate > secondStartDate) {
          return 1
        } else if (firstStartDate < secondStartDate) {
          return -1
        } else if (firstStartDate === secondStartDate) {
          if (a.bookingTypeName === 'A' && b.bookingTypeName === 'A') {
            const tempStartDate = moment(a.StartDate).format('MM-DD-YYYY HH:mm')
            const tempEndDate = moment(b.StartDate).format('MM-DD-YYYY HH:mm')
            if (tempStartDate > tempEndDate) {
              return 1
            } else {
              return -1
            }
          } else if (a.bookingTypeName === 'A') {
            return -1
          } else if (b.bookingTypeName === 'A') {
            return 1
          } else if (a.bookingTypeName === 'H' && b.bookingTypeName === 'C') {
            return -1
          } else if (a.bookingTypeName === 'C' && b.bookingTypeName === 'H') {
            return 1
          } else {
            return 0
          }
        }
      }

      //function to set ui-grid data
      function setGridData() {
        const startDate = moment($scope.dateFrom)
          .utc()
          .format('MM-DD-YYYY hh:mm')
        const endDate = moment($scope.dateTo).utc().format('MM-DD-YYYY hh:mm')

        const selectedClientId = clientSelectService.getSelectedClient().id
        let conversations = []
        progress.start()
        historySms
          .getConversations(startDate, endDate, selectedClientId)
          .then((response) => {
            conversations = response.data

            gridData = _.map(conversations, (obj) => {
              let tempData = {
                DisplayName: obj.Member.DisplayName,
                Phone: obj.Phone,
                LastUpdated: moment
                  .utc(obj.LastUpdated)
                  .local()
                  .format('MM-DD-YYYY HH:mm:ss'),
                Conversation: obj.Conversation,
                CarId: obj.CarId,
                FlightId: obj.FlightId,
                HotelId: obj.HotelId,
                TripId: obj.TripId,
                Channel: obj.Channel,
                Message: obj.Message,
              }

              let AgentName = ''
              if (
                obj.Message.indexOf('{') !== -1 ||
                (obj.Channel === 'messenger' && obj.TravelAgents.length === 0)
              ) {
                AgentName = 'Obex Bot, '
              }

              obj.TravelAgents.forEach(function (travelAgent) {
                AgentName +=
                  travelAgent.FirstName + ' ' + travelAgent.LastName + ', '
              })
              tempData.Email = obj.Member.Email ? obj.Member.Email : ''
              tempData.AlternateEmail = obj.Member.AlternateEmail ? obj.Member.AlternateEmail : ''
              tempData.AgentName =
                AgentName !== undefined && AgentName.length > 1
                  ? AgentName.substr(0, AgentName.length - 2)
                  : ''

              tempData.TravelAgents = obj.TravelAgents
              return tempData
            })
            updateGridPagination(gridData)
          })
          .catch((err) => {
            console.log(err)
          })
          .finally(() => {
            progress.complete()
          })
      }

      //entry point
      setGridData()

      function updateGridPagination(gridData) {
        $scope.gridDetails.data = gridData
        $scope.gridDetails.totalItems = gridData.length
      }

      $scope.searchSmsHistory = function () {
        setGridData()
      }

      function mapFlightContext(flightContext) {
        return flightContext.map(function (contextData) {
          let statusColor = '#000000' //black
          let flightStatus = 'scheduled'
          let currentDateTime = new Date()
          let arrivalTime = moment(contextData.ArrivalDateTime).format(
            'MM-DD-YYYY h:mm:ss',
          )
          currentDateTime = moment(currentDateTime).format('MM-DD-YYYY h:mm:ss')
          if (contextData.FlightStat !== null) {
            let departureTime = moment(contextData.DepartureDateTime).format(
              'MM-DD-YYYY h:mm:ss',
            )
            let estimatedDeparuteTime = moment(
              contextData.FlightStat.EstimatedDeparture,
            ).format('MM-DD-YYYY h:mm:ss')
            let estimatedArrival = moment(
              contextData.FlightStat.EstimatedArrival,
            ).format('MM-DD-YYYY h:mm:ss')
            statusColor =
              departureTime === estimatedDeparuteTime ||
                estimatedDeparuteTime < departureTime
                ? '#3d9400'
                : estimatedDeparuteTime > departureTime
                  ? '#cc0000'
                  : statusColor
            flightStatus =
              departureTime === estimatedDeparuteTime ||
                estimatedDeparuteTime < departureTime
                ? 'on time'
                : estimatedDeparuteTime > departureTime
                  ? 'delayed'
                  : currentDateTime > estimatedArrival
                    ? 'past flight'
                    : flightStatus
          }
          if (contextData.Cancelled === true) {
            statusColor = '#cc0000' //red
            flightStatus = 'cancelled'
          }
          if (
            contextData.FlightStat === null &&
            currentDateTime > arrivalTime
          ) {
            flightStatus = 'past flight'
          }
          return {
            statusColor: statusColor,
            flightStatus: flightStatus,
            estimatedDeparture:
              contextData.FlightStat !== null &&
                contextData.FlightStat.EstimatedDeparture !== null
                ? contextData.FlightStat.EstimatedDeparture
                : contextData.DepartureDateTime,
            estimatedArrival:
              contextData.FlightStat !== null &&
                contextData.FlightStat.EstimatedArrival !== null
                ? contextData.FlightStat.EstimatedArrival
                : contextData.ArrivalDateTime,
            pnr: contextData.Pnr,
            bookingTypeName: 'A',
            bookingType: 'Airline Reservation',
            depart:
              contextData.DepartureName +
              ' (' +
              contextData.DepartureAirport +
              ')',
            arrival:
              contextData.ArrivalName + ' (' + contextData.ArrivalAirport + ')',
            departureName: contextData.DepartureName,
            departureAirport: contextData.DepartureAirport,
            departureDateTime: moment(contextData.DepartureDateTime).format(
              'MM-DD-YYYY h:mm:ss',
            ),
            departureGate:
              contextData.FlightStat !== null &&
                contextData.FlightStat.DepartureGate !== null
                ? contextData.FlightStat.DepartureGate
                : '-',
            departureTerminal:
              contextData.FlightStat !== null &&
                contextData.FlightStat.DepartureTerminal !== null
                ? contextData.FlightStat.DepartureTerminal
                : '-',
            startDate: contextData.DepartureDateTime,
            endDate: contextData.ArrivalDateTime,
            arrivalName: contextData.ArrivalName,
            arrivalAirport: contextData.ArrivalAirport,
            arrivalDateTime: moment(contextData.ArrivalDateTime).format(
              'MM-DD-YYYY h:mm:ss',
            ),
            arrivalGate:
              contextData.FlightStat !== null &&
                contextData.FlightStat.ArrivalGate !== null
                ? contextData.FlightStat.ArrivalGate
                : '-',
            arrivalTerminal:
              contextData.FlightStat !== null &&
                contextData.FlightStat.ArrivalTerminal !== null
                ? contextData.FlightStat.ArrivalTerminal
                : '-',
            operatingAirline: contextData.OperatingAirline,
            flightNumber: contextData.FlightNumber,
            duration: contextData.Duration,
            bookingSource: contextData.BookingSource,
            confirmation: contextData.ConfirmationNumber,
            cabin: contextData.Cabin,
            bookingClass: contextData.BookingClass,
            numberInParty: contextData.NumberInParty,
            airTravelers: contextData.AirReservation.AirTravelers,
            comment: contextData.AirReservation.Comment,
            seats: contextData.Seats,
            totalCharge:
              currency.getCurrencySymbol(
                contextData.AirReservation.CurrencyCode,
              ) + contextData.AirReservation.TotalFare,
            lastUpdated: moment(contextData.Updated).format(
              'MM-DD-YYYY h:mm:ss',
            ),
            isDeleted: contextData.Deleted ? 'Yes' : 'No',
            vendor: contextData.Vendor,
          }
        })
      }

      function mapCarContext(carContext) {
        return carContext.map(function (contextData) {
          return {
            bookingTypeName: 'C',
            bookingType: 'Car Reservation',
            pnr: contextData.Pnr,
            startDate: contextData.PickUpDateTime,
            rentalCompany: contextData.RentalCompany,
            pickupDateTime: moment(contextData.PickUpDateTime).format(
              'MM-DD-YYYY h:mm',
            ),
            pickupLocation: contextData.PickUpLocation,
            pickupLocationIsAirport:
              contextData.PickUpAtAirport === true ? 'Yes' : 'No',
            pickupLocationPhoneNumber: contextData.PickUpLocationPhoneNumber,
            pickupLocationCode: contextData.PickUpLocationCode,
            dropoffDateTime: moment(contextData.DropOffDateTime).format(
              'MM-DD-YYYY h:mm',
            ),
            dropoffLocation: contextData.DropOffLocation,
            dropoffLocationIsAirport:
              contextData.DropOffAtAirport === true ? 'Yes' : 'No',
            dropoffLocationPhoneNumber: contextData.DropOffLocationPhoneNumber,
            dropoffLocationCode: contextData.DropOffLocationCode,
            carModel: contextData.CarModel,
            confirmation: contextData.Confirmation,
            bookingSource: contextData.BookingSource,
            totalCharge:
              contextData.TotalCharge +
              ' ' +
              (contextData.CurrencyCode === null
                ? ''
                : contextData.CurrencyCode),
            lastUpdated: moment(contextData.Updated).format(
              'MM-DD-YYYY h:mm:ss',
            ),
            isDeleted: contextData.Deleted === true ? 'Yes' : 'No',
          }
        })
      }

      function mapHotelContext(hotelContext) {
        return hotelContext.map(function (contextData) {
          return {
            bookingTypeName: 'H',
            bookingType: 'Hotel Reservation',
            pnr: contextData.Pnr,
            startDate: contextData.CheckInDate,
            hotelName: contextData.HotelName,
            address: contextData.Address,
            checkinDate: moment(contextData.CheckInDate).format('MM-DD-YYYY'),
            checkoutDate: moment(contextData.CheckOutDate).format('MM-DD-YYYY'),
            confirmation: contextData.Confirmation,
            bookingSource: contextData.BookingSource,
            guestNames: contextData.GuestNames,
            numberOfRooms: contextData.NumberOfRooms,
            roomType: contextData.RoomType,
            totalCharge:
              contextData.Total +
              ' ' +
              (contextData.CurrencyCode === null
                ? ''
                : contextData.CurrencyCode),
            lastUpdated: moment(contextData.Updated).format(
              'MM-DD-YYYY h:mm:ss',
            ),
            isDeleted: contextData.Deleted === true ? 'Yes' : 'No',
          }
        })
      }

      function mapLimoContext(limoContext) {
        return limoContext.map(function (contextData) {
          return {
            Id: contextData.Id,
            bookingTypeName: 'L',
            bookingType: 'Limo Reservation',
            startDate: contextData.DepartureDate,
            departureDate: moment(contextData.DepartureDate).format(
              'MM-DD-YYYY',
            ),
            departureTime: moment(contextData.DepartureDate).format('h:mm a'),
            limoServiceName: contextData.LimoServiceName,
            locationName: contextData.LocationName,
            bookingSource: contextData.BookingSource,
            cancelled: contextData.Cancelled,
            confirmation: contextData.Confirmation,
            dropOff: contextData.DropOff,
            IPCC: contextData.IPCC,
            imageLink: contextData.ImageLink,
            instructions: contextData.Instructions,
            pickUp: contextData.PickUp,
            pnr: contextData.Pnr,
            time: contextData.Time,
          }
        })
      }
      // Validate that filtered organization id is defined
      function validateOrganization() {
        const organization = clientSelectService.getSelectedClient()
        return organization.id != null && Number.isInteger(organization.id)
      }

      // Validate that filtered organization id is defined
      function validateAgencyAndClientSelection() {
        const agency = agencySelectService.getSelectedAgency()
        const client = clientSelectService.getSelectedClient()
        return {
          agencyValid: agency.id != null && Number.isInteger(agency.id),
          clientValid: client.id != null && Number.isInteger(client.id),
        }
      }

      angular.element(document).ready(function () { })
      // Watch clientSelectService for changes to getFilteredOrganization() output -- expensive, calls getFilteredOrganization many times during $digest cycle
      $scope.$watch(
        function () {
          return clientSelectService.getSelectedClient()
        },
        function (newValue, oldValue) {
          $scope.gridDetails.data = []
          $scope.gridDetails.totalItems = 0
          $scope.isInConversation = false
          $scope.bookingType = null
          $scope.chats = []
          $scope.showConversation = false
          if (newValue !== oldValue) {
            $scope.client = null
            $scope.selectedValue = null
            $timeout($scope.searchSmsHistory, 3000)
          }
        },
        true,
      )
    },
  ])
})(angular.module('obex'))



// WEBPACK FOOTER //
// ./client/js/controllers/smsHistoryController.js